import Loadable from 'react-loadable'
import Loading from '../../components/Loading'

export const Search = Loadable({
  loader: () => import('./containers/Search'),
  loading: Loading
})

export const EditProfile = Loadable({
  loader: () => import('./containers/EditProfile'),
  loading: Loading
})

export const SearchResult = Loadable({
  loader: () => import('./containers/SearchResult'),
  loading: Loading
})



// WEBPACK FOOTER //
// ./src/containers/Search/index.js